import { render } from "./CoachForm.vue?vue&type=template&id=9c9e48ae&scoped=true"
import script from "./CoachForm.vue?vue&type=script&lang=js"
export * from "./CoachForm.vue?vue&type=script&lang=js"

import "./CoachForm.vue?vue&type=style&index=0&id=9c9e48ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ACER\\Desktop\\Vue Course\\Main Course Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c9e48ae"]])

export default __exports__